import { Button } from '../../../../components/tailwind';
import React, { memo } from 'react';
import { Views } from '@types';

const TermsAndConditions = ({ setView }) => {
  return (
    <div>
      <h3 className='tw-mb-4 tw-text-lg tw-font-bold tw-text-brand-black'>MyRTIC Terms & Conditions</h3>

      <p className='tw-mb-3 tw-text-sm tw-leading-normal'>
        RTIC will review custom designed products prior to production. However, you are responsible for
        reviewing your customized content before placing your order. Once you have submitted the order, the
        order is final and cannot be changed or cancelled. We do not offer refunds on personalized products.
      </p>

      <p className='tw-mb-3 tw-text-sm tw-leading-normal'>
        All orders are subject to acceptance by RTIC. RTIC reserves the right to reject your order in its sole
        discretion and for any reason.
      </p>

      <p className='tw-mb-3 tw-text-sm tw-leading-normal'>
        RTIC may use custom designed products for marketing and promotional purposes.
      </p>

      <div className='tw-text-center'>
        <Button variant='link' onClick={() => setView(Views.REVIEW)}>
          Back To MyRTIC
        </Button>
      </div>
    </div>
  );
};

export default memo(TermsAndConditions);
